import React from 'react'
import AppButton from "../../ui/AppButton";
import Alert from "@material-ui/lab/Alert";
import Modal from "@material-ui/core/Modal";

class AlertVerifyEmail extends React.Component {

    render() {

        const {save, openModal, onCloseModal} = this.props;

        return (
            <Modal
                open={openModal}
                onClose={onCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Alert style={{textAlign: 'justify', width: '500px'}}
                       severity="info">

                    La respuesta a su solicitud le será enviada a través de la dirección de correo electrónico
                    diligenciado en este formulario, por lo tanto, verifique que los datos se registraron
                    correctamente. La notificación por medio electrónico se entenderá entregada por parte de
                    ELECTROHUILA S.A. E.S.P., una vez se obtenga la certificación del sistema de registro de
                    ciclo de comunicación Emisor-Receptor, suministrado por un ente certificador electrónico
                    validado para el territorio nacional.

                    <table style={{width: '100%', textAlign: 'center'}}>
                        <tbody>
                        <tr>
                            <td>

                                <span style={{padding: '5px'}}>
                                    <AppButton
                                        type='button'
                                        label='Aceptar'
                                        size='small'
                                        onClick={save}
                                    />
                                </span>

                                <span style={{padding: '5px'}}>
                                    <AppButton
                                        type='button'
                                        label='Cancelar'
                                        size='small'
                                        onClick={onCloseModal}
                                    />
                                </span>

                            </td>
                        </tr>
                        </tbody>
                    </table>

                </Alert>

            </Modal>
        );
    }

}

export default AlertVerifyEmail

